export default __webpack_public_path__ + "static/media/_DSC0744 (5).e05df9b0.jpg";